import { combineReducers } from 'redux'

import orchestration from './orchestration'

export const reducer = combineReducers({
  orchestration: orchestration.reducer,
})

export default reducer
